export const appClientVersion = '2.21.0';

export const appClientPlatform = 'WEB';
